import { RaiseText } from "../raise-components"
import React from "react"

import { QrCode } from "@atos6/components"
import { Button, Space, Text } from "@atos6/ui"
import { downloadImage } from "@atos6/utils"
import { Card } from "../App.styles"
import { useStore } from "../containers"

export function QrCell() {
  const { publicOnlineDonationUrl, isAccountCreated } = useStore()

  function downloadQrcode() {
    downloadImage(document.getElementById("qrcode-image") as HTMLElement, "qrcode.png")
  }

  return (
    <Card disabled={!isAccountCreated}>
      <RaiseText fontSize="20px" fontWeight="600" textAlign="center" marginBottom="30px">
        QR Code
      </RaiseText>
      <Space size="large">
        <QrCode value={publicOnlineDonationUrl} />
        <Text className="text-sm">
          Este é o QR code da sua página de doação, você pode usar nas mídias, postagens e
          transmissões online, após a leitura deste QR code abrirá a página de doação da sua
          instituição
        </Text>
      </Space>
      <div style={{ textAlign: "right" }}>
        <Button type="primary" onClick={downloadQrcode}>
          Salvar QR Code
        </Button>
      </div>
    </Card>
  )
}
